import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LegalComponent } from './legal.component';
import { LegalTermsComponent } from './legal-terms.component';

const legalRoutes: Routes = [
  {
    path: 'legal/privacy-policy',
    component: LegalComponent,
  },
  {
    path: 'legal/terms-of-service',
    component: LegalTermsComponent,
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(legalRoutes)
  ],
  exports: [
    RouterModule
  ],
})
export class LegalRoutingModule { }



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/legal-routing.module.ts